import {
  FaCalendarCheck,
  FaCalendarDay,
  FaChartLine,
  FaListOl,
  FaUserPlus,
  FaUserClock,
  FaEdit,
  FaRunning,
  FaCalendar,
  FaChalkboardTeacher,
  FaBook,
  FaCalendarAlt,
  FaClipboardList,
  FaClock,
  FaUsersCog,
  FaTasks,
  FaCrown,
  FaCalendarTimes,
} from "react-icons/fa";

import { MdEventAvailable } from "react-icons/md";
import { LuPartyPopper } from "react-icons/lu";

const iconMap = {
  FaCalendarCheck,
  FaCalendarDay,
  FaChartLine,
  FaListOl,
  FaUserPlus,
  FaUserClock,
  FaEdit,
  FaRunning,
  FaCalendar,
  FaChalkboardTeacher,
  FaBook,
  FaCalendarAlt,
  FaClipboardList,
  FaClock,
  FaUsersCog,
  FaTasks,
  FaCrown,
  FaCalendarTimes,
  MdEventAvailable,
  LuPartyPopper,
};

export default iconMap;
